import { render } from "./WordExamples.vue?vue&type=template&id=4a3ec590&scoped=true&ts=true"
import script from "./WordExamples.vue?vue&type=script&lang=ts"
export * from "./WordExamples.vue?vue&type=script&lang=ts"

import "./WordExamples.vue?vue&type=style&index=0&id=4a3ec590&scoped=true&lang=css"

import exportComponent from "/Users/eugene/My/Projects/ek22f/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3ec590"]])

export default __exports__